export default "__VITE_ASSET__TKa6C99j__"